import React, { ReactNode } from 'react';

import { Box, BoxProps } from '@mantine/core';

interface BoxedIconProps extends BoxProps {
  icon: ReactNode;
  hasBorder?: boolean;
  size?: number;
  isCircular?: boolean;
}

export function DroxyBoxedIcon({ icon, hasBorder, isCircular, size = 40, ...boxProps }: BoxedIconProps) {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.colors.gray[0],
        borderRadius: isCircular ? '50%' : theme.radius.md,
        width: size,
        height: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: hasBorder ? `1px solid ${theme.colors.gray[2]}` : 'none'
      })}
      {...boxProps}>
      {icon}
    </Box>
  );
}
